import React from "react";
import { useTranslateMessage } from "~utils/i18n";

export type MarketStatusProps = {
  isOpen: boolean | null;
  className?: string;
};

export default function MarketStatus(props: MarketStatusProps) {
  const { isOpen, className } = props;
  const translateMessage = useTranslateMessage();

  if (null === isOpen) {
    return null;
  }

  const openLabel = translateMessage({
    id: "marketOpen",
    defaultMessage: "Market open",
  });
  const closedLabel = translateMessage({
    id: "marketClosed",
    defaultMessage: "Market closed",
  });
  const marketState = isOpen ? openLabel : closedLabel;

  return <span className={className}>· {marketState}</span>;
}
